import { render, staticRenderFns } from "./facebook-share.vue?vue&type=template&id=1671042e&"
import script from "./facebook-share.vue?vue&type=script&lang=js&"
export * from "./facebook-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1671042e', component.options)
    } else {
      api.reload('1671042e', component.options)
    }
    module.hot.accept("./facebook-share.vue?vue&type=template&id=1671042e&", function () {
      api.rerender('1671042e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/facebook-share.vue"
export default component.exports